import { createSDKAction, onPending, onFulfill, onReject } from '../util';
import ActionTypes from '../action-types';
import { setAvailable } from '../../taskrouter';
import { ROUTES } from '../../../Constants';
import {
  getJobAgentSow as getJobAgentSowAction,
  getJobAgentHits as getJobAgentHitsAction
} from './me';
import { store } from '../index';

export function activate(jobId) {
  return createSDKAction(ActionTypes.JOB_ACTIVATE, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.JOB_ACTIVATE) });
      return sdk
        .api(`/jobAgent/active/${jobId}`, {
          requiresAuthentication: true,
          method: 'put'
        })
        .then(response => {
          dispatch({ type: onFulfill(ActionTypes.JOB_ACTIVATE), payload: { jobId } });

          return Promise.resolve(response.body);
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.JOB_ACTIVATE), payload: err });
          return Promise.reject(err);
        });
    }
  });
}

export function getAll() {
  const { me } = store.getState();
  const { metricsDuration } = me;
  const isMetricsEnabled = window._env_.AGENT_METRICS_ENABLED;

  return createSDKAction(ActionTypes.JOB_GET_ALL, {
    callback: (sdk, dispatch) => {
      dispatch({ type: onPending(ActionTypes.JOB_GET_ALL) });
      return sdk
        .api(`/jobAgent`, {
          requiresAuthentication: true,
          method: 'get',
          queryParams: { isMetricsEnabled, metricsDuration }
        })
        .then(response => {
          dispatch({ type: onFulfill(ActionTypes.JOB_GET_ALL), payload: response.body });

          return Promise.resolve(response.body);
        })
        .catch(err => {
          dispatch({ type: onReject(ActionTypes.JOB_GET_ALL), payload: err });
        });
    }
  });
}

export function gotoJob(job, history) {
  return async dispatch => {
    history.push(ROUTES.LOADING);

    try {
      if (!job.isActive) {
        await dispatch(activate(job.jobId));
      }

      const { executedHitsCount, maxHitsCount } = await dispatch(getJobAgentHitsAction(job.jobId));
      if (maxHitsCount != null && executedHitsCount >= maxHitsCount) {
        return history.push(ROUTES.NO_MORE_TASKS);
      }

      const { me } = store.getState();
      if (!me.agentIsVendor) {
        const { isSigned } = await dispatch(getJobAgentSowAction(job.jobId));

        if (!isSigned) {
          return history.push(ROUTES.SOW, { nextRoute: ROUTES.JOB });
        }
      }

      await setAvailable();

      return history.push(ROUTES.JOB);
    } catch (err) {
      return history.goBack();
    }
  };
}
